import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IPerson } from '@/Module/Auth/Model/DataModel';
import { AuthService } from '@/Module/Auth/Service';

export const authGetMyPersonAction = createAsyncThunk<IPerson, string | undefined>(
  'auth/getMyPerson',
  (token, { signal }) => {
    return AuthService.getMyPerson(token, signal).then(({ data: { data } }) => data);
  },
);
